<template>
  <div class="container">
    <div class="columns">
      <div class="column is-one-fifth" style="padding: 1.75rem">
        <div class="box" style="position: sticky; top: 1.75rem">
          <aside class="menu">
            <p :aria-label="$t('Jurisdiction')" class="menu-label">
              {{ $t("Jurisdiction") }}
            </p>
            <ul class="menu-list">
              <li v-for="(section, index) in sections" :key="index">
                <a :aria-label="section.label" :href="`#${section.name}`" class="has-text-link">
                  {{ section.label }}
                </a>
              </li>
            </ul>
          </aside>
        </div>
      </div>
      <div class="column">
        <section class="section">
          <div class="content">
            <a name="general"></a>
            <Content :data="content['general']" />
          </div>
        </section>

        <section class="section">
          <div class="content">
            <a name="1800"></a>
            <Content :data="content['1800']" />

            <img
              @click="openImageModal('district-1800.jpg', '1800')"
              :options="options"
              src="@/assets/images/district-1800.jpg"
            />
            <!-- <viewer
              @inited="inited"
              ref="viewer"
              :options="options"
              class="viewer"
            >
               <img
                  :options="options"
                  src="@/assets/images/district-1800.jpg"
                />
                <Legend :data="legend['1800']" />
            </viewer> -->
          </div>
        </section>

        <section class="section">
          <div class="content">
            <a name="1820"></a>
            <Content :data="content['1820']" />
            <img
              @click="openImageModal('district-1820.jpg', '1820')"
              :options="options"
              src="@/assets/images/district-1820.jpg"
            />
            <!-- <viewer
              @inited="inited"
              ref="viewer"
              :options="options"
              class="viewer"
            >
               <img
                  :options="options"
                  src="@/assets/images/district-1820.jpg"
                />
                <Legend :data="legend['1820']" />
            </viewer> -->
          </div>
        </section>

        <section class="section">
          <div class="content">
            <a name="1840"></a>
            <Content :data="content['1840']" />
            <img
              @click="openImageModal('district-1840.jpg', '1840')"
              :options="options"
              src="@/assets/images/district-1840.jpg"
            />
            <!-- <viewer
              @inited="inited"
              ref="viewer"
              :options="options"
              class="viewer"
            >
               <img
                  :options="options"
                  src="@/assets/images/district-1840.jpg"
                />
                <Legend :data="legend['1840']" />
            </viewer> -->
          </div>
        </section>

        <section class="section">
          <div class="content">
            <a name="1860"></a>
            <Content :data="content['1860']" />
            <img
              @click="openImageModal('district-1860.jpg', '1860')"
              :options="options"
              src="@/assets/images/district-1860.jpg"
            />
            <!-- <viewer
              @inited="inited"
              ref="viewer"
              :options="options"
              class="viewer"
            >
               <img
                  :options="options"
                  src="@/assets/images/district-1860.jpg"
                />
                <Legend :data="legend['1860']" />
            </viewer> -->
          </div>
        </section>

        <section class="section">
          <div class="content">
            <a name="1880"></a>
            <Content :data="content['1880']" />
            <img
              @click="openImageModal('district-1880.jpg', '1880')"
              :options="options"
              src="@/assets/images/district-1880.jpg"
            />
            <!-- <viewer
              @inited="inited"
              ref="viewer"
              :options="options"
              class="viewer"
            >
            <figure>
               <img
                  :options="options"
                  src="@/assets/images/district-1880.jpg"
                />
                <Legend :data="legend['1880']" />
            </figure>
            </viewer> -->
          </div>
        </section>

        <section class="section">
          <div class="content">
            <a name="1900"></a>
            <Content :data="content['1900']" />
            <img
              @click="openImageModal('district-1900.jpg', '1900')"
              :options="options"
              src="@/assets/images/district-1900.jpg"
            />
            <!-- <viewer
              @inited="inited"
              ref="viewer"
              :options="options"
              class="viewer"
            >
               <img
                  :options="options"
                  src="@/assets/images/district-1900.jpg"
                />
                <Legend :data="legend['1900']" />
            </viewer> -->
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>
html {
  position: relative;
}

.is-clickable {
  cursor: pointer !important;
}
</style>

<script>
import Placeholder from "@/components/Placeholder.vue";
import Content from "@/components/Content.vue";
import ImageModal from "@/components/ImageModal.vue";
import Legend from "@/components/Legend.vue";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import Vue from "vue";
Vue.use(VueViewer);

import localeMixin from "@/mixins/locale.js";

export default {
  layout: "main",
  mixins: [localeMixin],
  components: {
    Placeholder,
    Content,
    Legend,
    ImageModal,
  },
  data() {
    return {
      legend: require("@/assets/material/legend.json"),
      contentData: require("@/assets/material/content.json"),
    };
  },
  computed: {
    sections() {
      return this.contentData[this.locale]
        .filter((item) => item.name)
        .map((item) => ({
          name: item.name,
          label: item.label,
        }));
    },
    content() {
      return this.contentData[this.locale]
        .filter((value) => value.name)
        .reduce(
          (obj, value) => ({
            ...obj,
            [value.name]: value.content,
          }),
          {}
        );
    },
    options() {
      return {
        viewed: this.setViewerZoom,
        inline: false,
        navbar: false,
        title: false,
        toolbar: {
          zoomIn: {
            show: true,
            size: "large",
          },
          zoomOut: {
            show: true,
            size: "large",
          },
        },
        tooltip: false,
        zoomRatio: 0.25,
      };
    },
    viewers() {
      if (this.$refs.viewer) {
        if (!(this.$refs.viewer instanceof Array)) {
          return [this.$refs.viewer];
        } else {
          return this.$refs.viewer;
        }
      } else {
        console.warn("viewer not found");
        return [];
      }
    },
  },
  methods: {
    setViewerZoom(event) {
      if (event.originalTarget) {
        event.originalTarget.viewer.zoomTo(0.5);
      }
    },
    openImageModal(src, year) {
      this.$buefy.modal.open({
        parent: this,
        component: ImageModal,
        canCancel: true,
        fullScreen: true,
        props: {
          src: src,
          year: year,
        },
      });
    },
    inited(viewer) {

      this.$viewer = viewer;
    },
  },
};
</script>
